import React from 'react';
import { URL } from 'appConstants';
import MediaShell from '../MediaShell';
import MediaV4List from '../MediaV4List';

const MediaTechTours = () => (
  <MediaShell
    title="Технотуры"
    crumbCurrent="Технотуры"
  >
    <MediaV4List
      requestUrl={URL.NEWS.TECHTOURS.GET}
      badge="ТЕХНОТУРЫ"
      action="opener"
    />
  </MediaShell>
);

export default MediaTechTours;
